import Environment from '../../Environment';
import { IFilter, IInclude, buildUrl } from '../BaseService';

export interface IPrepareWebAppUrl {
  filters?: IFilter[];
  id?: string;
  includes?: IInclude[];
}

export function prepareWebApprUrl({
  filters,
  id,
  includes,
}: IPrepareWebAppUrl): string {
  return buildUrl({
    host: Environment.builderService,
    resource: 'web-apps',
    filters,
    includes,
    id,
  });
}
